export const error = {
  requiredField: 'Campo obrigatório! Não é possível deixá-lo em branco.',
  queueWithoutSpecialCharacter: 'Use apenas letras e números no nome da equipe',
};
